/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TransactionType = 0 | 1;

export const TransactionType = {

    NUMBER_0: 0 as TransactionType,

    NUMBER_1: 1 as TransactionType
};

